import * as React from "react";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import DatePickerComponent from "../../ui/datepicker/DatePickerComponent";
import {option} from "ts-option";
import DateUtils from "../../../utils/DateUtils";
import LinkPresenter from "../LinkPresenter";
import "../common/commonDetailsInfoRow.scss";
import moment = require("moment");

interface IProps {
	/**
	 * Info items to be displayed.
	 */
	items: DetailsInfoRowItem[];
	/**
	 * If true, inputs are rendered instead of editable items labels.
	 */
	editMode?: boolean;
}

export interface DetailsInfoRowItem {
	/**
	 * Item label.
	 */
	label: string;
	/**
	 * Item value.
	 */
	value: any;
	/**
	 * Url to redirect to on click (if item is a link).
	 */
	url?: string
	/**
	 * Item type.
	 */
	itemType?: CommonDetailsInfoRowType;
	/**
	 * Item value change callback.
	 */
	onChange?: (value: any) => void;
	/**
	 * If true, item edit mode input is clearable.
	 */
	clearable?: boolean
	/**
	 * Custom input
	 */
	customInput?: JSX.Element
}

export default class CommonDetailsInfoRow extends React.PureComponent <IProps, {}> {
	render() {
		return (
			<div className="c-common-info_row-container">
				<div className="c-common-info_row-inner-container">
					{this.props.items.map((item, index) => this.renderDetailsInfoItem(item, index, this.props.editMode))}
				</div>
			</div>
		);
	}

	renderDetailsInfoItem = (item: DetailsInfoRowItem, index: number, editMode: boolean) => {
		if (editMode) {
			switch (item.itemType) {
				case CommonDetailsInfoRowType.Date:
					return this.renderDateInput(item, index);
				case CommonDetailsInfoRowType.String:
					return this.renderTextInput(item, index);
				default:
					return this.renderTextInput(item, index);
			}
		}
		return this.renderLabel(item, index);
	};

	renderLabel = (item: DetailsInfoRowItem, index: number) =>
		<div className="c-common-info_row-item" key={index}>
			<div className="c-common-info_row-item_label">{item.label}</div>
			<div className="c-common-info_row-item_value">
				{this.renderValue(item)}
			</div>
		</div>;

	renderValue = (item: DetailsInfoRowItem) => {
		if (item.value) {
			switch (item.itemType) {
				case CommonDetailsInfoRowType.Date:
					return item.value.format(DateUtils.DATE_FORMAT);
				case CommonDetailsInfoRowType.Link:
					return <LinkPresenter label={item.value} url={item.url}/>;
				default:
					return item.value;
			}
		}
	};

	renderDateInput = (item: DetailsInfoRowItem, index: number) =>
		<div className="c-common-info_row-item" key={index}>
			<div className="c-common-info_row-item_label">{item.label}</div>
			<DatePickerComponent disabled={!item.onChange}
								 value={option(item.value as moment.Moment)}
								 onChange={(value) => item.onChange(value)}
								 clearable={item.clearable}
								 customInput={item.customInput}/>
		</div>;

	renderTextInput = (item: DetailsInfoRowItem, index: number) =>
		<div className="c-common-info_row-item" key={index}>
			<div className="c-common-info_row-item_label">{item.label}</div>
			<div className="c-common-info_row-item_edit-mode">
				<Input type={"text"}
					   disabled={!item.onChange}
					   value={item.value as string}
					   onChange={(e) => item.onChange(e.target.value)}/>
			</div>
		</div>;
};

export enum CommonDetailsInfoRowType {
	String = "STRING",
	Date = "DATE",
	Link = "LINK"
}
